import { render, staticRenderFns } from "./invite-share.vue?vue&type=template&id=0da0b172&scoped=true"
import script from "./invite-share.vue?vue&type=script&lang=js"
export * from "./invite-share.vue?vue&type=script&lang=js"
import style0 from "./invite-share.vue?vue&type=style&index=0&id=0da0b172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da0b172",
  null
  
)

export default component.exports